import { render } from "./IconElectraThrottle.vue?vue&type=template&id=30e5178a"
import script from "./IconElectraThrottle.vue?vue&type=script&lang=js"
export * from "./IconElectraThrottle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__